import React from "react"

const Perforation = () => {
  return (
    <div className="hidden md:block w-px self-stretch my-4 border-l-2 border-dashed border-[#DCE1E8]" />
  )
}

export default Perforation
